import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigaonrentinmumbai() {



  const cardData = {




keyword: "Ertiga On Rent in Mumbai",

headingDescription: "Garud Cab Service provides comfortable and reliable Ertiga On Rent in Mumbai for families, corporate travelers, tourists, couples, senior citizens, and small groups looking for a spacious and economical vehicle with a professional chauffeur. Customers can hire an Ertiga for Mumbai local travel, airport transfers, railway station pickups, corporate meetings, family functions, sightseeing, one-way journeys, round trips, and outstation trips. With experienced drivers, clean and well-maintained vehicles, comfortable seating, practical luggage space, flexible pickup locations across Mumbai, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes group travel convenient and stress-free. The Ertiga is a suitable choice for city travel as well as longer road journeys, with flexible booking options based on passenger count, travel duration, destination, and customized itinerary requirements.",

topPlaces: [
  {
    title: "Murbad",
    description: "Murbad is a peaceful destination near Mumbai surrounded by hills, greenery, and countryside landscapes, making it suitable for short family getaways and weekend road trips. An Ertiga provides comfortable seating for small groups traveling with luggage. Garud Cab Service offers chauffeur-driven rentals with flexible pickup and return arrangements from different parts of Mumbai."
  },
  {
    title: "Karnala",
    description: "Karnala is known for the Karnala Bird Sanctuary and historic Karnala Fort, offering a combination of nature, trekking, and heritage experiences close to Mumbai. Families and small groups can comfortably travel in an Ertiga for a day trip. Customers can customize their booking to include sightseeing stops around the Karnala region."
  },
  {
    title: "Karjat",
    description: "Karjat is a popular weekend destination surrounded by waterfalls, hills, rivers, farms, and scenic countryside. It is suitable for family outings, group trips, and short holidays from Mumbai. Garud Cab Service provides a spacious Ertiga with a professional driver, allowing customers to travel comfortably with luggage and flexible sightseeing plans."
  },
  {
    title: "Kashid",
    description: "Kashid is a beautiful coastal destination known for its sandy beach, greenery, and peaceful seaside atmosphere. Families and groups planning a beach holiday from Mumbai can choose an Ertiga for comfortable long-distance travel. Customers can book a private chauffeur-driven vehicle with flexible pickup, overnight, and return travel arrangements."
  },
  {
    title: "Matheran",
    description: "Matheran is a scenic hill station near Mumbai known for forested hills, viewpoints, walking trails, and a peaceful atmosphere. An Ertiga is convenient for transporting families and small groups to the vehicle-access areas before continuing the hill-station visit. Garud Cab Service provides flexible rental arrangements for day trips and longer stays."
  },
  {
    title: "Bhandardara",
    description: "Bhandardara is a scenic destination in the Sahyadri ranges known for lakes, waterfalls, mountains, forests, and peaceful surroundings. Families and groups can enjoy a comfortable road journey in an Ertiga with enough space for passengers and luggage. Customers can plan a customized Mumbai to Bhandardara trip with flexible sightseeing stops."
  },
  {
    title: "Daman",
    description: "Daman is a popular coastal getaway known for beaches, forts, churches, waterfront areas, and relaxed holiday surroundings. It is suitable for families and small groups planning an outstation trip from Mumbai. Garud Cab Service provides chauffeur-driven Ertiga rentals with comfortable seating, practical luggage capacity, and flexible one-way or round-trip options."
  },
  {
    title: "Silvassa",
    description: "Silvassa is a green destination known for gardens, lakes, tribal heritage, and relaxed surroundings, making it suitable for family vacations and weekend trips. Customers can hire an Ertiga from Mumbai for comfortable group transportation throughout the journey. Flexible travel plans can include sightseeing and nearby attractions according to the preferred schedule."
  },
  {
    title: "Nashik",
    description: "Nashik is a major religious, cultural, and business destination known for temples, heritage sites, vineyards, and scenic surroundings. Families and small groups can comfortably travel from Mumbai in an Ertiga for pilgrimage, sightseeing, or personal visits. Garud Cab Service provides private chauffeur-driven transportation with customizable one-way and round-trip options."
  },
  {
    title: "Shirdi",
    description: "Shirdi is an important pilgrimage destination and is visited by devotees traveling from Mumbai throughout the year. The Ertiga is suitable for families and small groups who want comfortable seating and enough luggage space during the journey. Customers can arrange a private cab with flexible pickup, temple visit, overnight stay, and return travel requirements."
  }
],





"services": [
{
"name": "Ertiga CNG on Rent in Mumbai",
"description": "Book Ertiga CNG on Rent in Mumbai for comfortable and practical transportation with spacious seating and efficient travel. The vehicle is suitable for local trips, airport transfers, family journeys, corporate travel, sightseeing, and outstation transportation."
},
{
"name": "Ertiga on Hire in Mumbai",
"description": "Choose Ertiga on Hire in Mumbai for convenient chauffeur-driven transportation with comfortable seating and useful luggage space. It is suitable for families, small groups, business travelers, airport passengers, sightseeing, and long-distance journeys."
},
{
"name": "Ertiga Rent Per KM in Mumbai",
"description": "Check Ertiga Rent Per KM in Mumbai according to the selected route, travel distance, pickup location, and journey requirements. The vehicle can be arranged for local travel, airport transfers, business trips, family journeys, and outstation routes."
},
{
"name": "Ertiga Car on Rent in Mumbai",
"description": "Book Ertiga Car on Rent in Mumbai for spacious and comfortable private transportation with professional chauffeur assistance. The vehicle is suitable for daily travel, airport transfers, family trips, corporate requirements, sightseeing, and intercity journeys."
},
{
"name": "Ertiga on Rent in Mumbai",
"description": "Choose Ertiga on Rent in Mumbai for flexible transportation with practical seating and luggage capacity. It can be arranged for city travel, airport pickup and drop, family outings, corporate travel, events, sightseeing, and outstation journeys."
},
{
"name": "Ertiga Cab in Mumbai",
"description": "Book Ertiga Cab in Mumbai for comfortable chauffeur-driven transportation suitable for families and small groups. The service provides convenient travel for airport transfers, business trips, sightseeing, local transportation, and long-distance journeys."
},
{
"name": "Ertiga Taxi in Mumbai",
"description": "Choose Ertiga Taxi in Mumbai for spacious and convenient private travel with professional driver assistance. The vehicle is suitable for families, groups, tourists, corporate passengers, airport transfers, and customers planning local or outstation trips."
},
{
"name": "Ertiga Car Rental Mumbai",
"description": "Book Ertiga Car Rental Mumbai for practical and comfortable transportation with flexible rental options. The vehicle can be arranged for daily use, airport transfers, corporate travel, family journeys, sightseeing, events, and outstation transportation."
},
{
"name": "Ertiga Hire in Mumbai",
"description": "Choose Ertiga Hire in Mumbai for comfortable group transportation with spacious seating and luggage capacity. It is suitable for family trips, business travel, airport transfers, sightseeing, events, and long-distance road journeys."
},
{
"name": "Ertiga Cab Service Mumbai",
"description": "Book Ertiga Cab Service Mumbai for reliable chauffeur-driven transportation with convenient pickup and drop arrangements. The service is suitable for families, corporate travelers, airport passengers, tourists, groups, and customers traveling within or outside Mumbai."
},
{
"name": "Ertiga Taxi Service Mumbai",
"description": "Choose Ertiga Taxi Service Mumbai for comfortable private transportation with a spacious vehicle and experienced chauffeur. The service can be arranged for airport transfers, business travel, family journeys, sightseeing, events, and outstation routes."
},
{
"name": "Ertiga Cab Booking Mumbai",
"description": "Make Ertiga Cab Booking Mumbai for scheduled private transportation with convenient pickup arrangements. The vehicle is suitable for airport travel, family trips, corporate journeys, sightseeing, events, and intercity travel according to passenger requirements."
},
{
"name": "Ertiga Taxi Booking Mumbai",
"description": "Book Ertiga Taxi Booking Mumbai in advance for comfortable group transportation with professional chauffeur assistance. Customers can arrange the vehicle for local travel, airport transfers, family outings, business trips, tourism, and outstation journeys."
},
{
"name": "Ertiga on Rent Mumbai Price",
"description": "Check Ertiga on Rent Mumbai Price according to rental duration, travel distance, route, pickup location, and vehicle requirements. The spacious vehicle is suitable for families, groups, airport passengers, corporate travelers, sightseeing, and long-distance travel."
},
{
"name": "Ertiga Cab Fare Mumbai",
"description": "Find Ertiga Cab Fare Mumbai based on the journey distance, pickup point, destination, rental duration, and selected travel plan. The vehicle provides a practical option for families, groups, corporate passengers, airport transfers, and outstation travel."
},
{
"name": "Ertiga Taxi Charges Mumbai",
"description": "Check Ertiga Taxi Charges Mumbai according to the route, travel distance, rental period, and journey requirements. Customers can choose Ertiga for comfortable local transportation, airport transfers, family trips, business travel, and outstation journeys."
},
{
"name": "Best Ertiga Cab in Mumbai",
"description": "Choose the Best Ertiga Cab in Mumbai for comfortable and spacious chauffeur-driven transportation. The vehicle is suitable for families, small groups, corporate passengers, airport transfers, sightseeing, events, and private long-distance travel."
},
{
"name": "Cheap Ertiga on Rent in Mumbai",
"description": "Book Cheap Ertiga on Rent in Mumbai for economical group transportation with comfortable seating and practical luggage space. The service is suitable for families, students, business travelers, tourists, airport passengers, and budget-conscious customers."
},
{
"name": "Ertiga Airport Cab Mumbai",
"description": "Choose Ertiga Airport Cab Mumbai for comfortable airport pickup and drop transportation with sufficient passenger and luggage space. The service is suitable for families, groups, business travelers, and passengers traveling to or from Mumbai airports."
},
{
"name": "Ertiga Outstation Cab Mumbai",
"description": "Book Ertiga Outstation Cab Mumbai for comfortable long-distance travel with spacious seating and professional chauffeur service. It is suitable for family trips, group journeys, business travel, sightseeing, religious tours, and intercity transportation."
},
{
"name": "Ertiga Corporate Cab Mumbai",
"description": "Choose Ertiga Corporate Cab Mumbai for convenient employee, client, and business transportation. The spacious vehicle is suitable for meetings, corporate visits, airport transfers, office travel, events, and scheduled intercity business journeys."
},
{
"name": "Ertiga Wedding Cab Mumbai",
"description": "Book Ertiga Wedding Cab Mumbai for comfortable transportation of family members, guests, and small groups during wedding functions. The vehicle provides practical seating and luggage space for venue transfers, airport pickups, ceremonies, and related travel."
},
{
"name": "Ertiga Family Cab Mumbai",
"description": "Choose Ertiga Family Cab Mumbai for spacious and convenient transportation for family outings and long journeys. The vehicle is suitable for airport transfers, sightseeing, vacations, family functions, shopping trips, and outstation travel."
},
{
"name": "Ertiga Cab in Andheri",
"description": "Book Ertiga Cab in Andheri for comfortable transportation within Andheri and to Mumbai airport or outstation destinations. The service is suitable for families, groups, corporate passengers, airport transfers, sightseeing, and intercity journeys."
},
{
"name": "Ertiga Cab in Borivali",
"description": "Choose Ertiga Cab in Borivali for spacious chauffeur-driven transportation with convenient pickup arrangements. It is suitable for family travel, airport transfers, business trips, local journeys, sightseeing, and outstation routes from Borivali."
},
{
"name": "Ertiga Cab in Bandra",
"description": "Book Ertiga Cab in Bandra for comfortable private transportation suitable for families, groups, business travelers, and tourists. The vehicle can be arranged for airport transfers, local travel, events, sightseeing, and long-distance journeys."
},
{
"name": "Ertiga Cab in Thane",
"description": "Choose Ertiga Cab in Thane for spacious transportation between Thane, Mumbai, airports, Navi Mumbai, and outstation destinations. The service is suitable for families, groups, corporate travelers, tourists, and passengers carrying additional luggage."
},
{
"name": "Ertiga Cab in Navi Mumbai",
"description": "Book Ertiga Cab in Navi Mumbai for comfortable group transportation with practical seating and luggage capacity. It is suitable for airport transfers, corporate travel, family journeys, sightseeing, local travel, and intercity routes."
},
{
"name": "Ertiga on Rent Near Me Mumbai",
"description": "Choose Ertiga on Rent Near Me Mumbai for convenient chauffeur-driven transportation with flexible pickup from your preferred location. The vehicle is suitable for family trips, airport transfers, corporate travel, sightseeing, events, and outstation journeys."
},
{
"name": "Mumbai to Pune Ertiga Cab",
"description": "Book Mumbai to Pune Ertiga Cab for comfortable intercity transportation with spacious seating and luggage capacity. The service is suitable for families, groups, business travelers, airport passengers, and individuals planning a private journey between Mumbai and Pune."
},
{
"name": "Mumbai Airport Ertiga Taxi",
"description": "Choose Mumbai Airport Ertiga Taxi for convenient airport pickup and drop with enough space for passengers and luggage. The service is suitable for families, groups, corporate travelers, tourists, and passengers traveling from Mumbai airport to their preferred destination."
},
{
"name": "Mumbai to Nashik Ertiga Cab",
"description": "Book Mumbai to Nashik Ertiga Cab for comfortable long-distance transportation with a spacious vehicle and professional chauffeur. It is suitable for family trips, business travel, sightseeing, religious visits, and private intercity journeys."
},
{
"name": "Mumbai to Shirdi Ertiga Cab",
"description": "Choose Mumbai to Shirdi Ertiga Cab for comfortable private travel to Shirdi with convenient pickup arrangements. The vehicle is suitable for families and groups planning religious visits, pilgrimage trips, sightseeing, and round-trip journeys."
},
{
"name": "Mumbai to Goa Ertiga Cab",
"description": "Book Mumbai to Goa Ertiga Cab for spacious and comfortable road travel with professional chauffeur assistance. The service is suitable for families, friends, groups, tourists, and passengers planning a private long-distance journey to Goa."
},
{
"name": "Mumbai to Lonavala Ertiga Cab",
"description": "Choose Mumbai to Lonavala Ertiga Cab for comfortable travel to Lonavala with convenient pickup and destination drop. The vehicle is suitable for families, groups, weekend trips, sightseeing, resort visits, and private road journeys."
}
],
"tableData": [
["Ertiga CNG on Rent in Mumbai", "Ertiga on Hire in Mumbai"],
["Ertiga Rent Per KM in Mumbai", "Ertiga Car on Rent in Mumbai"],
["Ertiga on Rent in Mumbai", "Ertiga Cab in Mumbai"],
["Ertiga Taxi in Mumbai", "Ertiga Car Rental Mumbai"],
["Ertiga Hire in Mumbai", "Ertiga Cab Service Mumbai"],
["Ertiga Taxi Service Mumbai", "Ertiga Cab Booking Mumbai"],
["Ertiga Taxi Booking Mumbai", "Ertiga on Rent Mumbai Price"],
["Ertiga Cab Fare Mumbai", "Ertiga Taxi Charges Mumbai"],
["Best Ertiga Cab in Mumbai", "Cheap Ertiga on Rent in Mumbai"],
["Ertiga Airport Cab Mumbai", "Ertiga Outstation Cab Mumbai"],
["Ertiga Corporate Cab Mumbai", "Ertiga Wedding Cab Mumbai"],
["Ertiga Family Cab Mumbai", "Ertiga Cab in Andheri"],
["Ertiga Cab in Borivali", "Ertiga Cab in Bandra"],
["Ertiga Cab in Thane", "Ertiga Cab in Navi Mumbai"],
["Ertiga on Rent Near Me Mumbai", "Mumbai to Pune Ertiga Cab"],
["Mumbai Airport Ertiga Taxi", "Mumbai to Nashik Ertiga Cab"],
["Mumbai to Shirdi Ertiga Cab", "Mumbai to Goa Ertiga Cab"],
["Mumbai to Lonavala Ertiga Cab", "Ertiga Airport Cab Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Ertiga on Rent in Mumbai for Flexible Travel",
    WhyChoosedescription: "Hiring an Ertiga in Mumbai is a convenient option for families, small groups, corporate travellers, and tourists who need a practical vehicle for city travel, airport transfers, sightseeing, and outstation journeys."
  },
  {
    WhyChooseheading: "Comfortable Choice for Small Groups",
    WhyChoosedescription: "The Ertiga offers a practical seating arrangement for families and small groups, with useful luggage space for everyday trips, airport transfers, and planned journeys outside Mumbai."
  },
  {
    WhyChooseheading: "Convenient for Mumbai Airport Transfers",
    WhyChoosedescription: "An Ertiga can be arranged for airport pickup and drop requirements, making it useful for families and groups travelling with multiple passengers and regular travel luggage."
  },
  {
    WhyChooseheading: "Useful for Corporate Transportation",
    WhyChoosedescription: "Professionals and businesses can hire an Ertiga for office visits, meetings, client appointments, conferences, corporate events, and daily business travel across Mumbai."
  },
  {
    WhyChooseheading: "Suitable for Mumbai City Travel",
    WhyChoosedescription: "The vehicle can be used for shopping trips, hotel transfers, family outings, restaurant visits, local sightseeing, and travel between different areas of Mumbai."
  },
  {
    WhyChooseheading: "Good Option for Outstation Journeys",
    WhyChoosedescription: "An Ertiga can also be arranged for road trips from Mumbai to destinations such as Pune, Lonavala, Mahabaleshwar, Nashik, Surat, and other preferred cities."
  },
  {
    WhyChooseheading: "One-Way & Round-Trip Availability",
    WhyChoosedescription: "Travellers can select a one-way arrangement for direct transportation or choose a round trip when the vehicle is needed for sightseeing, business visits, holidays, or the return journey."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your Mumbai pickup location, destination, travel date, passenger count, luggage requirements, trip type, and Ertiga rental preference with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Ertiga on rent in Mumbai?",
    answer: "Yes, Garud Cab Service provides Ertiga rental options in Mumbai for local travel, airport transfers, corporate transportation, sightseeing, family outings, and outstation trips."
  },
  {
    question: "Can I rent an Ertiga for Mumbai sightseeing?",
    answer: "Yes, an Ertiga can be arranged for planned Mumbai sightseeing, shopping trips, family outings, hotel transfers, and travel between different city destinations."
  },
  {
    question: "Can I hire an Ertiga for Mumbai Airport transfers?",
    answer: "Yes, an Ertiga can be booked for airport pickup and drop services when you need a comfortable vehicle for passengers and luggage."
  },
  {
    question: "Is Ertiga suitable for families?",
    answer: "Yes, the Ertiga is a practical choice for families and small groups looking for a spacious and convenient vehicle for city and outstation travel."
  },
  {
    question: "Can companies rent an Ertiga in Mumbai?",
    answer: "Yes, businesses can arrange an Ertiga for office travel, meetings, client visits, conferences, corporate events, and other professional transportation needs."
  },
  {
    question: "Can I use the rented Ertiga for outstation travel?",
    answer: "Yes, the Ertiga can be arranged for outstation journeys from Mumbai to destinations such as Pune, Lonavala, Mahabaleshwar, Nashik, Surat, and other locations."
  },
  {
    question: "Can I book an Ertiga for a one-way journey?",
    answer: "Yes, one-way arrangements can be planned when you need direct transportation from Mumbai to your selected destination without requiring the vehicle for the return trip."
  },
  {
    question: "Can I book an Ertiga for a round trip?",
    answer: "Yes, round-trip arrangements can be planned for holidays, sightseeing, family visits, business travel, and other journeys requiring transportation back to Mumbai."
  },
  {
    question: "Can I carry luggage in the Ertiga?",
    answer: "Yes, passengers can carry luggage according to the available vehicle capacity. Additional or bulky luggage requirements should be communicated during booking."
  },
  {
    question: "How can I book an Ertiga on rent in Mumbai?",
    answer: "Share your Mumbai pickup location, destination, travel date, passenger details, luggage requirements, one-way or round-trip preference, and Ertiga rental requirement with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Vivek Joshi",
    feedback: "We hired an Ertiga in Mumbai for a family outing and found the seating arrangement practical for our group. The vehicle also gave us enough convenience for carrying our travel bags.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Neha Patil",
    feedback: "Our small team used an Ertiga for business travel across Mumbai. It was convenient to have everyone travelling together between meetings and office locations.",
    rating: 5
  }
];









  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga On Rent in Mumbai",
  "image": "https://garudcabs.com/assets/images/ertiga-on-rent-in-mumbai.webp",
  "description": "Hire Ertiga On Rent in Mumbai with Garud Cab for comfortable and dependable local, airport, corporate, and outstation travel. Get Maruti Ertiga rental and cab services with flexible per-kilometer and trip-based options, including Ertiga CNG availability, for family journeys, business travel, sightseeing, airport transfers, and long-distance transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/ertiga-on-rent-in-mumbai"
  }
};








  return (
    <div>

<Helmet>
  <title>Ertiga On Rent in Mumbai | Ertiga Cab & Car Hire | +91 9970007784</title>

  <meta
    name="description"
    content="Book Ertiga On Rent in Mumbai with Garud Cab for reliable local, airport, corporate, and outstation travel. Get Ertiga car rental, CNG rental, and cab services with flexible trip and per-kilometer options for family and business journeys."
  />

  <meta
    name="keywords"
    content="Ertiga CNG On Rent in Mumbai, Ertiga On Hire in Mumbai, Ertiga Rent Per Km in Mumbai, Ertiga Car on Rent in Mumbai, Ertiga On Rent in Mumbai, Ertiga Cab in Mumbai, Ertiga Rental Mumbai, Maruti Ertiga On Rent Mumbai, Ertiga Car Hire Mumbai, Ertiga Taxi Mumbai, Ertiga Outstation Cab Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/99.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ertigaonrentinmumbai;